var _path, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconNewProductUploader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 142,
    viewBox: "0 0 143 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.738 71.0004C140.738 109.435 109.593 140.58 71.1581 140.58C32.7235 140.58 1.57812 109.435 1.57812 71.0004C1.57812 32.5657 32.7235 1.42041 71.1581 1.42041C109.593 1.42041 140.738 32.5657 140.738 71.0004Z",
    fill: "url(#paint0_linear_1545_9252)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1545_9252)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.745 78.8583L107.711 78.8949C106.604 80.0709 105.497 81.2816 105.22 82.1463C104.909 83.1148 105.116 84.8443 105.324 86.4701L105.335 86.5603C105.678 89.409 106.065 92.6196 104.217 95.1867C102.386 97.764 99.2248 98.3797 96.4288 98.9244L96.2613 98.957L96.1206 98.9845C94.5731 99.2869 92.9864 99.597 92.2142 100.168C91.4227 100.718 90.6311 102.194 89.8736 103.605L89.8736 103.605L89.8621 103.627C88.4785 106.186 86.8874 109.126 83.7743 110.13C83.0479 110.372 82.3215 110.475 81.6297 110.475C79.3911 110.475 77.2854 109.478 75.3455 108.558L75.3454 108.558L75.2306 108.504L74.9421 108.369C73.5445 107.717 72.1175 107.051 71.1144 107.051C70.0767 107.051 68.4855 107.777 66.9982 108.504L66.9128 108.544C64.3733 109.746 61.465 111.122 58.4891 110.13C55.376 109.126 53.7848 106.186 52.4012 103.627C52.3428 103.522 52.2843 103.418 52.2258 103.313C51.4889 101.995 50.7542 100.68 50.0491 100.168C49.2789 99.6319 47.6981 99.323 46.1542 99.0214L46.0021 98.9916C43.1657 98.4728 39.9489 97.8502 38.0464 95.2213C36.1786 92.6271 36.559 89.3756 36.9395 86.5047C37.1471 84.8789 37.3546 83.184 37.0433 82.1809C36.7686 81.2881 35.6416 80.0885 34.5762 78.9543L34.5528 78.9295L34.5186 78.8929C32.5208 76.7574 30.2637 74.3447 30.2637 71.043C30.2637 67.7764 32.5063 65.3802 34.4891 63.2615L34.5874 63.1565C34.6965 63.0368 34.8063 62.9172 34.9158 62.7978C35.883 61.744 36.8293 60.7128 37.0779 59.905C37.3892 58.9365 37.1817 57.207 36.9741 55.5813L36.9632 55.491C36.6198 52.6423 36.2327 49.4317 38.081 46.8646C39.9122 44.2874 43.0732 43.6716 45.8691 43.1269L46.0367 43.0943L46.1773 43.0668C47.7248 42.7644 49.3116 42.4544 50.0837 41.8836C50.8753 41.333 51.6669 39.8578 52.4244 38.446L52.4358 38.4247C53.8194 35.865 55.4106 32.9249 58.5236 31.9217C61.4996 30.9298 64.4079 32.3057 66.9474 33.5071L67.0328 33.5475L67.3214 33.682C68.719 34.3343 70.1459 35.0003 71.149 35.0003C72.1521 35.0003 73.579 34.3343 74.9766 33.682L75.2652 33.5475C77.8248 32.3368 80.765 30.9532 83.7743 31.9217C86.8874 32.9249 88.4785 35.8304 89.8621 38.4247C89.9206 38.5289 89.9791 38.6335 90.0376 38.7381C90.7745 40.0565 91.5092 41.3709 92.2142 41.8836C92.9845 42.4195 94.5653 42.7283 96.1091 43.03L96.2613 43.0597C99.0976 43.5786 102.315 44.2012 104.217 46.83C106.085 49.4243 105.704 52.6757 105.324 55.5467C105.116 57.1724 104.909 58.8673 105.22 59.8704C105.495 60.7632 106.622 61.9628 107.687 63.097L107.711 63.1219L107.745 63.1584C109.743 65.294 112 67.7066 112 71.0084C112 74.3102 109.743 76.7228 107.745 78.8583ZM77.3391 64.2288C77.3391 65.7853 76.0939 67.0306 74.5373 67.0306L69.2105 67.0998V68.2412H71.1475C72.7041 68.2412 73.9493 69.4865 73.9493 71.043C73.9493 72.5996 72.7041 73.8448 71.1475 73.8448H69.2105V74.9863H74.5373C76.0939 74.9863 77.3391 76.2315 77.3391 77.788C77.3391 79.3446 76.0939 80.5898 74.5373 80.5898H66.4087C64.8522 80.5898 63.6069 79.3446 63.6069 77.788V64.2288C63.6069 62.6722 64.8522 61.427 66.4087 61.427H74.5373C76.0939 61.427 77.3391 62.6722 77.3391 64.2288ZM58.2801 61.4269C56.7236 61.4269 55.4783 62.6722 55.4783 64.2287V67.6531L52.5382 62.7759C51.881 61.7036 50.6011 61.1848 49.3905 61.5307C48.1798 61.8766 47.3151 62.9835 47.3151 64.2287V77.788C47.3151 79.3445 48.5603 80.5898 50.1169 80.5898C51.6734 80.5898 52.9187 79.3445 52.9187 77.788V74.3636L55.8588 79.2407C56.3777 80.1055 57.3116 80.6243 58.2801 80.6243C58.5222 80.6243 58.7644 80.5898 59.0411 80.5206C60.2517 80.1747 61.1165 79.0678 61.1165 77.8226V64.2633C61.0819 62.6722 59.8366 61.4269 58.2801 61.4269ZM89.3753 64.2288C89.3753 62.6722 90.6205 61.427 92.1771 61.427C93.7336 61.427 94.9789 62.6722 94.9789 64.2288V77.788C94.9789 78.9987 94.2179 80.071 93.0764 80.4515C92.7997 80.5206 92.4884 80.5898 92.1771 80.5898C91.3123 80.5898 90.4822 80.1748 89.9287 79.483L86.7465 75.2976L83.5642 79.483C82.8378 80.4515 81.5926 80.832 80.4511 80.4515C79.3096 80.071 78.5486 78.9987 78.5486 77.788V64.2288C78.5486 62.6722 79.7939 61.427 81.3504 61.427C82.907 61.427 84.1522 62.6722 84.1522 64.2288V69.4519L84.5327 68.9676C85.605 67.584 87.9225 67.584 88.9948 68.9676L89.3753 69.4519V64.2288Z",
    fill: "#98A2B3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1545_9252)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 71.1591,
    cy: 71.0004,
    r: 61.3872,
    stroke: "#98A2B3",
    strokeWidth: 4.07895
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1545_9252",
    x: 30.2637,
    y: 31.5815,
    width: 81.7363,
    height: 80.4039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.50984
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.754919
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1545_9252"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1545_9252",
    x: 7.73242,
    y: 7.57373,
    width: 126.854,
    height: 128.485,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.63158
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.815789
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1545_9252"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1545_9252",
    x1: 22.8781,
    y1: 16.5671,
    x2: 124.408,
    y2: 115.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71136,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAC1CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNewProductUploader);
export default __webpack_public_path__ + "static/media/IconNewProductUploader.010fd83932fe2c4778a24ca636fbd669.svg";
export { ForwardRef as ReactComponent };